//External
import React from "react";
import ReactHtmlParser from "react-html-parser";
import { Row, Col } from "react-bootstrap";
import SocialShare from "components/socialshare";

/*******************
  @Purpose :  used for Blog detail
  @Parameter : {data}
  @Author : INIC
  *******************/
const blogDetail = ({ data }) => {
  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="header-spacer">
        <div className="custom-container">
          <Row className="justify-content-md-center">
            <Col md={10}>
              {/* Banner : Start */}
              <section className="blog-details-banner">
                <div className="bdb-title-box">
                  <h1 className="title">{data?.title}</h1>
                  <p className="sub-title">BY FALCON CAR RENTAL</p>
                </div>

                <div className="bdb-img-box">
                  <img src={data.featured_image} alt="" className="bdb-img" />
                </div>
              </section>
              {/* Banner : End */}

              {/* Common Content Block : Start */}
              <section className="common-content-section">
                {ReactHtmlParser(
                  data?.page_body?.replace(/\\n/g, "").replace(/\\r/g, "")
                )}
              </section>
            </Col>

            <Col md={10}>
              <div className="section-divider mb-3"></div>
            </Col>
          </Row>
        </div>
      </div>
      <SocialShare data={data} />
    </>
  );
};
export default blogDetail;
